<!-- <button  class="text-xxs rounded-3 btn btn-sm btn-secondary shadow-sm" data-bs-toggle="modal" data-bs-target="#event_modal">+ Create Event</button> -->



<div v-if="$route.name === 'view_portal' && can_create_portal_actions" class="card border-0 rounded-5 shadow-sm mb-4" data-bs-toggle="modal"
  data-bs-target="#event_modal">
  <div class="card-body p-3">
    <!-- Profile Section -->
    <div class="d-flex align-items-center">
      <div class="input-container flex-grow-1">
        <input type="text text-xxs" class="form-control bg-light border-0" placeholder="Write something ..."
          aria-label="Post content">
      </div>
    </div>
    <hr class="my-2 d-none d-sm-flex">
    <!-- Action Buttons -->
    <div class="d-flex justify-content-between d-none d-sm-flex">
      <span
        class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-danger">
        <i class="bi bi-calendar-event action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Events</span>
      </span>
      <span
        class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-success">
        <i class="bi bi-clock action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Schedule</span>
      </span>
      <span
        class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-warning">
        <i class="bi bi-people action-icon"></i>
        <span class="text-xs ms-2 d-none d-md-inline">Meeting</span>
      </span>
    </div>
  </div>
</div>


<!-- Otherwise, show full feed card -->
<div v-else-if="$route.name === 'view_incidents' && can_create_incident_actions"
  class="card border-0 rounded-5 shadow-sm mb-3" data-bs-toggle="modal" data-bs-target="#incidentReportModal"
  >
  <div>

    <div class="card-body p-3">
      <!-- Profile Section -->
      <div class="d-flex align-items-center">
        <div class="input-container flex-grow-1">
          <input type="text text-xxs" class="form-control bg-light border-0" placeholder="What's on your mind?"
            aria-label="Post content" readonly data-bs-toggle="modal" data-bs-target="#incidentReportModal">
        </div>
      </div>
      <hr class="my-2 d-none d-sm-flex">
      <!-- Action Buttons -->
      <div class="d-flex justify-content-between d-none d-sm-flex">
        <span
          class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-danger">
          <i class="bi bi-file-earmark-pdf action-icon"></i>
          <span class="text-xs ms-2 d-none d-md-inline" data-bs-toggle="modal"
            data-bs-target="#incidentReportModal">Document</span>
        </span>
        <span
          class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-success"
          data-bs-toggle="modal" data-bs-target="#incidentReportModal">
          <i class="bi bi-images action-icon"></i>
          <span class="text-xs ms-2 d-none d-md-inline" data-bs-toggle="modal"
            data-bs-target="#incidentReportModal">Photo/video</span>
        </span>
        <span
          class="rounded-3 btn btn-light flex-grow-1 mx-1 d-flex align-items-center justify-content-center text-warning"
          data-bs-toggle="modal" data-bs-target="#incidentReportModal">
          <i class="bi bi-record-circle action-icon"></i>
          <span class="text-xs ms-2 d-none d-md-inline">Recordings</span>
        </span>
      </div>
    </div>

  </div>
</div>
<div v-else-if="$route.name === 'view_events'" class="position-relative">
    <button class="btn btn-sm nav-item bg-primary text-white rounded shadow" type="button" id="createDropdown" data-bs-toggle="modal" data-bs-target="#event_modal"
    aria-expanded="false" v-if="token_exists && can_create_event_actions && (user_details.user_role === 'admin' || !cbo_domain) && active_tab !== 'promo_codes'">
    Add event
  </button>

  <ul class="dropdown-menu" aria-labelledby="createDropdown">
    <li>
      <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#event_modal" href="#">
        Create Event
      </a>
    </li>

    <li>
      <a class="dropdown-item" data-bs-toggle="modal" data-bs-target="#event_ticket_modal" href="#">
        Create Ticket Types
      </a>
    </li>
  </ul>
</div>






<div class="dropdown d-none">
  <button class="dropdown-toggle bg-transparent border-0 text-dark" type="button" id="dropdownMenuButton1"
    data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
    <i class='bx bx-plus fs-3 text-dark'></i>
  </button>

  <!-- Dropdown Menu -->
  <ul class="dropdown-menu dropdown-menu-end rounded-5 shadow border-0" aria-labelledby="dropdownMenuButton1">
    <li v-if="can_create_feed_actions && !isGroupPage && !isIncidentPage && !isEventsPage && !isCommunityAssetPage">
      <a class="dropdown-item border-bottom" href="#" data-bs-toggle="modal" data-bs-target="#feed_modal">
        <i class='bx bxs-report fs-6'></i>Feed
      </a>
    </li>
    <li v-if="can_create_feed_actions && !isGroupPage && !isIncidentPage && !isEventsPage && !isCommunityAssetPage">
      <a class="dropdown-item border-bottom" href="#" data-bs-toggle="modal" data-bs-target="#voice_modal">
        <i class='bx bxs-message-dots fs-6'></i>Voice
      </a>
    </li>
    <li
      v-if="can_create_asset_actions && (!isPortalPage && !isGroupPage && !isIncidentPage && !isHomePage && !isHomeFilter && !isEventsPage && !isViewPortalPage || isCommunityAssetPage)">
      <a class="dropdown-item border-bottom " href="#" data-bs-toggle="modal"
        data-bs-target="#create_community_asset_modal">
        <i class='bx bxs-message-dots fs-6'></i>Community Asset
      </a>
    </li>
    <li
      v-if="can_create_feed_actions && !isHomePage && !isPortalPage && !isViewPortalPage && !isIncidentPage && !isEventsPage && !isCommunityAssetPage">
      <a class="dropdown-item border-bottom" href="#" data-bs-toggle="modal" data-bs-target="#group_feed_modal">
        <i class='bx bxs-message-dots fs-6'></i>Group Feed
      </a>
    </li>
    <li
      v-if="can_create_feed_actions && !isHomePage && !isPortalPage && !isViewPortalPage && !isIncidentPage && !isEventsPage && !isCommunityAssetPage">
      <a class="dropdown-item border-bottom" href="#" data-bs-toggle="modal" data-bs-target="#group_voice_modal">
        <i class='bx bxs-message-dots fs-6'></i>Group Voice
      </a>
    </li>
    <li
      v-if="can_create_portal_actions && !isPortalPage && !isViewPortalPage && !isIncidentPage && !isHomePage && !isHomeFilter && !isEventsPage && !isCommunityAssetPage">
      <a class="dropdown-item border-bottom" href="#" data-bs-toggle="modal" data-bs-target="#group_modal">
        <i class='bx bxs-message-dots fs-6'></i>Group
      </a>
    </li>
    <li v-if="can_create_portal_actions && !isGroupPage && !isEventsPage && user_details.user_role !== 'user' && !isCommunityAssetPage">
      <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#portal_modal">
        <i class='bx bxs-message-dots fs-6'></i>Portal
      </a>
    </li>
    <li
      v-if="can_create_portal_actions && !isHomePage && !isEventsPage && !isIncidentPage && !isGroupPage && user_details.user_role !== 'user' && !isCommunityAssetPage">
      <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#segment_modal">
        <i class='bx bxs-message-dots fs-6'></i>Segment
      </a>
    </li>
    <li
      v-if="can_create_portal_actions && !isHomePage && !isEventsPage && !isIncidentPage && !isGroupPage && !isCommunityAssetPage && !isHomeFilter && !isPortalPage">
      <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#document_approval_modal">
        <i class='bx bxs-message-dots fs-6'></i>Document/Media Approval
      </a>
    </li>
    <li
      v-if="can_create_portal_actions && !isHomePage && !isEventsPage && !isIncidentPage && isViewPortalPage && !isPortalPage && created_by_id == user_details.user_id && !isCommunityAssetPage">
      <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#group_member_modal">
        <i class='bx bxs-message-dots fs-6'></i>Group Member
      </a>
    </li>
    <li v-if="can_create_incident_actions && !isHomePage && !isEventsPage && !isPortalPage && !isViewPortalPage && !isCommunityAssetPage">
      <a class="dropdown-item" href="#" data-bs-toggle="modal" data-bs-target="#incidentReportModal">
        <i class='bx bxs-message-dots fs-6'></i>Incident
      </a>
    </li>
    <li v-if="!isHomePage && !isHomeFilter && !isPortalPage && !isViewPortalPage && !isCommunityAssetPage">
      <a v-if="can_create_event_actions" class="dropdown-item" data-bs-toggle="modal"
        data-bs-target="#event_modal">Add event
      </a>
    </li>
  </ul>
</div>



<teleport to="body">
<!-- Group Modal -->
<div class="modal fade" id="group_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scroll">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xs fw-500" id="exampleModalLabel">Create a Group</p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="createGroup">
        <div class="modal-body modal-body-scroll">

          <div class="mb-3">
            <label for="group_name" class="form-label text-xs fw-500">Group Name <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control rounded-5 text-xs" id="group_name" placeholder="Enter group name"
              v-model="group_name">
            <p v-if="errors.group_name" class="text-danger text-xs">{{ errors.group_name }}</p>
          </div>
          <QuillEditor theme="snow" v-model="description" ref="quillGroupEditorRef" class="quill-editor"
            placeholder="Enter your description here..." toolbar="full" />
          <div class="form-check mt-2">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="public" value="public"
              v-model="selectedVisibility">
            <label class="form-check-label text-xs fw-500" for="flexRadioDefault1">
              Public <br>
              <span class="text-xxs text-secondary">Is the group public ?</span>
            </label>
          </div>
          <div class="form-check mt-2">
            <input class="form-check-input" type="radio" name="flexRadioDefault" id="private" value="private"
              v-model="selectedVisibility">
            <label class="form-check-label text-xs fw-500" for="private">
              Private <br>
              <span class="text-xxs text-secondary">Is the group private ?</span>
            </label>
          </div>

        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Post</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Group member modal -->
<div class="modal fade" id="group_member_modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scroll">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xs fw-500" id="exampleModalLabel">Add a group member</p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="add_group_member">
        <div class="modal-body modal-body-scroll">
          <table class="table table-striped text-xs">
            <thead class="btn-primary text-white">
              <tr>
                <th scope="col">#</th>
                <th scope="col">First Name</th>
                <th scope="col">Last Name</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody class="text-black">
              <tr v-for="(user, index) in users" :key="user.id" v-show="user.role.role === 'user'">
                <th scope="row">{{ index + 1 }}</th>
                <td>{{ user.first_name }}</td>
                <td>{{ user.last_name }}</td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" :id="'member_check_' + user.id" :value="user.id"
                      v-model="selectedUserIds" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Add member</button>
        </div>
      </form>
    </div>
  </div>
</div>

<!-- Community Asset Modal -->
<div class="modal fade" id="create_community_asset_modal" tabindex="-1" aria-labelledby="exampleModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scroll">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title text-xs fw-500" id="exampleModalLabel">Create Community Assets</p>
        <button type="button" class="btn-close text-xs fw-500" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <form @submit.prevent="createcommunity_asset">
        <div class="modal-body modal-body-scroll">

          <div class="mb-3">
            <label for="asset_name" class="form-label text-xs fw-500">Community Asset Name <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control rounded-5 text-xs" id="asset_name"
              placeholder="Enter community asset name" v-model="asset_name">
            <p v-if="errors.asset_name" class="text-danger text-xs">{{ errors.asset_name }}</p>
          </div>
          <div class="mb-3">
            <label for="asset_name" class="form-label text-xs fw-500">Community Asset Location <span
                class="text-danger">*</span></label>
            <input type="text" class="form-control rounded-5 text-xs" id="location"
              placeholder="Enter community asset name" v-model="location" :class="{'is-invalid': errors.location}">
            <p v-if="errors.location" class="text-danger text-xs">{{ errors.location }}</p>
          </div>
          <div class="mb-3">
            <label for="category_id" class="form-label text-xs fw-500">Select a Category<span
                class="text-danger">*</span></label>
            <select class="form-select rounded-5 text-xs" id="category_id" v-model="category_id">
              <option selected hidden>Select a Category</option>
              <option v-for="category in categories" :value="category.id" :key="category.id">{{ category.name }}
              </option>
            </select>
            <p v-if="errors.category_id" class="text-danger text-xs">{{ errors.category_id }}</p>
          </div>
          <div class="mb-3">
            <label for="asset_name" class="form-label text-xs fw-500">Subscription fee</label>
            <input type="text" class="form-control rounded-5 text-xs" id="subscription_fee" placeholder="R0"
              v-model="subscription_fee">
            <p v-if="errors.subscription_fee" class="text-danger text-xs">{{ errors.subscription_fee }}</p>
          </div>
          <QuillEditor theme="snow" v-model="description" ref="quillAssetEditorRef" class="quill-editor"
            placeholder="Enter your description here..." toolbar="full" />
          <div class="mt-2 mx-1">
            <div class="d-flex flex-row justify-content-between">
              <div class="file-upload">
                <label for="fileInput" class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light"><i
                    class='bx bx-image-add file-upload-icon'></i> Add community content</label>
                <input type="file" id="fileInput" class="file-input d-none" @change="handleFileUpload" />
              </div>
              <div v-if="fileName" class="text-xs mt-2 text-secondary text-danger fst-italic"><span class="fw-500">File
                  name:</span>{{ fileName }}</div>
            </div>
            <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>

            <div v-if="imagePreview" class="mt-2">
              <img :src="imagePreview" alt="Preview" class="img-fluid rounded"
                style="max-width: 200px; max-height: 200px;" />
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary text-xs rounded-5">Post</button>
        </div>
      </form>
    </div>
  </div>
</div>

<div class="modal fade" id="incidentReportModal" tabindex="-1" aria-labelledby="incidentReportModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-scroll">
    <div class="modal-content">
<!-- Modal Header -->
<div class="modal-header">
        <h5 class="modal-title text-xs fw-500" id="incidentReportModalLabel">Create Incident Report for <span id="incidentReportCardType"></span></h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
<!-- Modal Form -->
<form @submit.prevent="createIncidentReport">
        <div class="modal-body modal-body-scroll">
  
          <div class="mb-4">
            <label class="form-label text-xs fw-500">Report Name <span class="text-danger">*</span></label>
            <input
              type="text"
              id="incidentReportName"
              class="form-control text-xs rounded-5"
              placeholder="Enter report name here..."
              v-model="report_title"
            />
            <p v-if="errors.incident_title" class="text-danger text-xs">{{ errors.incident_title}}</p>
          </div>
          {{portal_id}}

          <div class="d-flex flex-row justify-content-between mx-1">
            <div class="d-none" >
              <label for="portals" class="form-label text-xs fw-500"><span class="text-danger">*</span>Tag a portal :</label>
              <select class="text-xs btn-primary fw-500 border-0 rounded-5 btn-sm mb-3 border-end"
                v-model="selectedPortalId" @change="onPortalChange" id="portals">
                <option value="" selected hidden>
                  * Tag a portal
                </option>
                <option v-for="portal in portals " :value="portal.id" :key="portal.id">{{ portal.name }}</option>
              </select>
              <p v-if="errors.portal" class="text-danger text-xs">{{ errors.portal }}</p>
            </div>
          </div>
          <div class="mb-4">
            <label class="form-label text-xs fw-500">Incident Description <span class="text-danger">*</span></label>
            <QuillEditor
              theme="snow"
              ref="quillReportEditorRef" class="quill-editor"
              placeholder="Enter description here..."
              toolbar="full"
            />
          </div>
          <p v-if="errors.incident_description" class="text-danger text-xs">{{ errors.incident_description }}</p>
  
<!-- Contact Persons Section -->
<div class="file-upload my-2 me-4 flex-grow-1 d-flex flex-column align-items-start">
            <label for="fileInput" class="text-xs text-secondary fw-500 border-0 rounded-5 btn-sm mb-3 bg-light d-flex align-items-center justify-content-center">
              <i class='bx bx-image-add file-upload-icon'></i> Add Report content
            </label>
            <input type="file" id="fileInput" class="file-input d-none" @change="handleFileUpload" />
            <div v-if="fileName" class="text-xs text-secondary fst-italic mt-1">
              <span class="fw-500">File name:</span> {{ fileName }}
            </div>
            <div v-if="fileError" class="text-xs text-danger fst-italic mt-1">{{ fileError }}</div>
          </div>
  
          <div class="mb-4">
            <label for="mapSearchBox" class="form-label text-xs fw-500 d-block">Search for Location</label>
            <input id="mapSearchBox" type="text" class="form-control map-search-box rounded-4" placeholder="Search location..." v-model="location" />
            <p  v-if="errors.location" class="text-danger text-xs">{{ errors.location }}</p>
          </div>
        </div>
  
<!-- Modal Footer -->
<div class="modal-footer">
          <button type="button" class="btn btn-primary rounded-3 text-xxs shadow-sm" data-bs-dismiss="modal">Cancel</button>
          <button type="submit" class="btn btn-primary text-xxs rounded-3 shadow-sm">Create Report</button>
        </div>
      </form>
    </div>
  </div>
  </div>
</teleport>
